import React, {useState, useEffect} from 'react'
import ClaudeAiCustomData from '../whitaijiFrontendLibrary/components/ClaudeAiCustomData'
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { songsData } from '../data/songsData';
import * as pdfjsLib from 'pdfjs-dist';
import { getDocument } from 'pdfjs-dist/webpack';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import T from '../components/Translation';
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import { _FETCH } from '../utils/patches';


pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


const TellMeHowYouFeel = () => {

  const navigate = useNavigate();
  const {hideTestButtons, language, apiUrl} = useStateContext()
  const [customData, setCustomData] = useState([]);
  const [aiData, setAiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {user} = useAuthContext(AuthContext)
  const queryClient = useQueryClient()

  const { data: songsDataDb, error, isLoading: isLoadingSongsDb } = useQuery({
    queryKey: ['songsData'],
    enabled: !!user, // Only fetch if user is logged in
    queryFn: async () => {
        const songs = await _FETCH({
          route: `${apiUrl}/songs/without-prelude`,
          user
        });
        return songs;
      }
});

  useEffect(() => {
    const loadPdfContent = async () => {
      try {
        // Load the PDF file
        const response = await fetch('/aiReferenceDocs/reMind Book.pdf');
        const arrayBuffer = await response.arrayBuffer();
        
        // Load PDF document
        const loadingTask = getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;
        
        // Extract text from each page
        const textContent = [];
        for (let i = 1; i <= pdf?.numPages; i++) {
          const page = await pdf?.getPage(i);
          const content = await page?.getTextContent();
          const pageText = content?.items
            ?.map(item => item?.str)
            ?.join(' ')
            ?.trim();
          
          if (pageText) {
            textContent?.push(pageText);
          }
        }
        
        setCustomData(textContent);
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error('Error loading PDF:', error);
        setCustomData(['Error loading PDF content']);
      } finally {
        setIsLoading(false);
      }
    };

    loadPdfContent();
  }, []);
  const aiPrompt =  `
  You are an accomplished psychologist, your job is to suggest one or more songs and the most
  fitting lyric lines to use as affirmations to the problem the user is describing. Use natural language and explain the lyrics in depth.
  Do not answer anything that is not related to mental health or personal development. if ${language} === "it", respond in italian, leaving the lyrics in english, 
  if ${language} === "en", respond in english.
  `
  
  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("TEST", aiPrompt, songsDataDb) 
  }

  if(isLoading) {
    return <Loading/>
  }
  return (
    <div style={{padding: "30px"}}>
      <BlueButton hide={hideTestButtons} text={"Test Button"} fn={testFunction}/>
      <div style={{padding: "20px", display: "flex", justifyContent: "flex-start"}}>
        <BlueButton 
          home
          buttonStyle={{fontSize: "16px", padding: "10px 20px"}}
        />
      </div>
      <div style = {{display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <h3 style={{textAlign: 'center', marginBottom: user ? '0px' : '15px', marginTop: '15px'}}><T obj={{
          it: "Descrivimi come ti senti in dettaglio, l'intelligenza artificiale analizzerà il libro reMind e ti consiglierà la canzone da ascoltare e le parti del testo su cui concentrarti.", 
          en: "Describe in detail how you feel, and ai will search the reMind book to recommend a song to listen to and the lyrics to focus on."
        }}/></h3>
      </div>  
      {!user?.isSubscribed &&  <div style = {{display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <p style={{textAlign: 'center', marginBottom: user ? '0px' : '15px', marginTop: '15px'}}>
          <T obj={{
            it: "Iscrivendoti e abbonandoti a reMind, potrai salvare il risultato nel tuo dashboard.", 
            en: "By signing up and subscribing to reMind, you will be able to save the result in your dashboard."
          }}/>
          <T obj={{
          it: ` Non essendo ancora iscritto, IA prende in considerazione solo i capitoli del libro reMind e le canzoni "What if" sull'ansia, "Mr Perfect" sul perfezionismo
           ed "As far as it takes" sul lutto e tristezza. `, 
          en: ` As you are not yet subscribed, the AI only considers the chapters from the reMind book and the songs "What if" about anxiety, "Mr Perfect" about perfectionism,
          and "As Far As It Takes" about grief and sadness.`,
          
        }}/></p>
      </div> }
      {isLoading ? (
          <T obj={{
            it: "Carico il libro reMind...", 
            en: "Loading the reMind book..."
          }}/>

      ) : (
        <ClaudeAiCustomData 
          placeholder = 
                { language === "en" ? "Tell me how you feel in detail... (Press Enter to send, Shift+Enter for new line" :  
                "Descrivimi come ti senti in dettaglio... (Premi Invio per spedire, Shift+Invio per andare a capo"
              }
          customData={customData} 
          systemPrompt={aiPrompt} 
          stream={true}
          strict={true}
          onSaveAiData={setAiData}
          songsData = {songsDataDb}
          responseExamples = {false}
        />
      )}
    </div>
  )
}

export default TellMeHowYouFeel
